var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"name":"termly-embed","data-id":"0d8b6557-9413-44b3-9cc4-51a8066ba2d3","data-type":"iframe"}})}
var staticRenderFns = []

export { render, staticRenderFns }